import React, { useEffect, useState, useCallback } from "react";

import {
  Link as ReactLink,
  useParams,
  useHistory,
  useLocation,
} from "react-router-dom";
import Swal from "sweetalert2";
import { format } from "date-fns";

import { Flex, SimpleGrid, useDisclosure, Text, Link } from "@chakra-ui/react";

import Group from "../../ServicosAcolhimento/Visualizar/Group";
import Information from "../../ServicosAcolhimento/Visualizar/Information";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { CustomButton } from "../../../components/CustomButton";
import { FiliacaoTableVisualizacao } from "../Filiacao/TableVisualizacao";

import CriancaService from "../../../../main/services/CriancaService";
import { generateAddressFiliacao } from "../../../utils/generateAddressFiliacao";
import {
  Permission,
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import {
  HINT_PORTAL_EXTRAJUDICIAL,
  useDescricaoGenero,
} from "../../../../helpers/hints";
import HintIcone from "../../../components/HintIcone";
import { CadastrarMovimentacaoModal } from "../Movimentacao/Cadastrar";
import { cpf } from "../../../utils/masks";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { useAppContext } from "../../../../Context/MessageContextProvider";

export const VisualizarCrianca = ({ setLoadingPainel }) => {
  const { id } = useParams();
  const location = useLocation();
  const excluir = new URLSearchParams(location.search).get("excluir");
  const history = useHistory();
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();

  const {
    isOpen: isOpenNovoAcolhimento,
    onOpen: onOpenNovoAcolhimento,
    onClose: onCloseNovoAcolhimento,
  } = useDisclosure();

  const [data, setData] = useState();
  const descricaoGenero = useDescricaoGenero();

  const columns = [
    {
      Header: "Vínculo",
      accessor: "tipoFiliacao",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Nome",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        if (props?.value?.idCriancaFiliacaoAcolhido) {
          return (roleKeycloack &&
            roleKeycloack.includes(criancaFunc.visualizar)) ||
            roleKeycloack.includes(
              servicoAcolhimentoFunc.visualizarPartePPCAAM
            ) ? (
            <Link
              title={props?.value?.nome}
              as={ReactLink}
              to={"/crianca/" + props?.value.idCriancaFiliacaoAcolhido}
            >
              <span>{props?.value?.nome}</span>
            </Link>
          ) : (
            <span>{props?.value?.nome}</span>
          );
        } else {
          return <span>{props?.value?.nome}</span>;
        }
      },
    },
    {
      Header: "CPF",
      accessor: "cpf",
      Cell: (props) => {
        return (
          <Text whiteSpace="nowrap">{props.value ? cpf(props.value) : ""}</Text>
        );
      },
    },
    {
      Header: "Endereço",
      accessor: "endereco",
      sortType: (rowA, rowB, id, desc) => {
        const enderecoA = generateAddressFiliacao(rowA.original);
        const enderecoB = generateAddressFiliacao(rowB.original);

        return enderecoA.localeCompare(enderecoB, "pt-BR");
      },
      Cell: (props) => {
        return <span>{generateAddressFiliacao(props.row.original)}</span>;
      },
    },
    {
      Header: "Observações",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return (
          <span>
            {props?.value?.falecido === "S" ? (
              <>
                Falecido
                <HintIcone hint={HINT_PORTAL_EXTRAJUDICIAL} rotulo="Falecido" />
              </>
            ) : props?.value?.idCriancaFiliacaoAcolhido ? (
              "Acolhido(a)"
            ) : (
              ""
            )}
          </span>
        );
      },
    },
  ];

  const backAlertDelete = () => {
    Swal.fire({
      title: "Atenção",
      text: "Deseja realmente excluir ficha da criança/adolescente?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        CriancaService.deleteCrianca(id)
          .then((res) => {
            history.push(`/crianca`);
            Swal.fire({
              title: "Sucesso!",
              text: "Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            });
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error.response.data.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      }
    });
  };

  const handleGetCrianca = useCallback(() => {
    CriancaService.getCrianca(id)
      .then((res) => {
        let primeiraMovimentacaoGet;
        let temRiscoVida;

        if (res.data.movimentacoes && res.data.movimentacoes.length > 0) {
          const movimentacoesComData = res.data.movimentacoes.filter(
            (item) => item.ordem
          );

          if (movimentacoesComData.length > 0) {
            movimentacoesComData.sort((a, b) => b.ordem - a.ordem);

            primeiraMovimentacaoGet = movimentacoesComData[0];

            if (
              primeiraMovimentacaoGet?.movimentoMovimentacao?.id === 1 ||
              primeiraMovimentacaoGet?.movimentoMovimentacao?.id === 6
            ) {
              const movimentacoes = movimentacoesComData || [];

              for (const mov of movimentacoes) {
                if (
                  mov?.movimentoMovimentacao?.id === 3 ||
                  !mov?.movimentoMovimentacao?.id
                ) {
                  temRiscoVida = mov?.motivoSituacao?.riscoVida === "S";
                  break;
                }
              }
            }
          }
        }

        if (
          (primeiraMovimentacaoGet?.motivoSituacao?.riscoVida === "S" ||
            temRiscoVida) &&
          roleKeycloack &&
          roleKeycloack.length > 0 &&
          !roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
          !(
            (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
              roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              res.data?.servicoAcolhimento?.idPessoaJuridica
            )
          )
        ) {
          Swal.fire({
            title: "Atenção!",
            text: "Por favor, entre em contato com o Gestor do MCA.",
            icon: "warning",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          }).then((result) => {
            if (result.isConfirmed) {
              history.push("/crianca");
            }
          });
        } else {
          const modifiedData = {
            ...res.data,
            movimentacoes: ordenarMovimentacoes(res.data.movimentacoes),
          };
          setData(modifiedData);
        }
      })
      .catch((err) => {});
  }, [id, history, setData, roleKeycloack, user?.orgaoExterno]);

  useEffect(() => {
    handleGetCrianca();
  }, [handleGetCrianca]);

  const ordenarMovimentacoes = (movimentacoes) => {
    return movimentacoes.sort((a, b) => b.ordem - a.ordem);
  };

  return data ? (
    <Flex flexDir="column">
      <Group title="Identificação">
        <Information title="Nome:" information={data ? data.nome : ""} />
        <Information
          title="Nome Social:"
          information={data.nomeSocial ? data.nomeSocial : ""}
        />
        <Information
          title="Data de Nascimento:"
          information={
            data?.dataNascimento
              ? format(data?.dataNascimento, "dd/MM/yyyy") +
                (data?.dataNascimentoEstimada === "S" ? " (Estimada)" : "")
              : ""
          }
        />
        <Information
          title="Gênero:"
          hintText={descricaoGenero(data.genero?.genero)}
          information={data.genero ? data.genero.genero : ""}
        />
        <Information
          title="Raça/Cor:"
          information={data.raca ? data.raca.raca : ""}
        />
        <Information
          title="Nacionalidade:"
          information={
            data.nacionalidade ? data.nacionalidade.nacionalidade : ""
          }
        />
        <Information
          title="Naturalidade:"
          information={data.naturalidade ? data.naturalidade.nome : ""}
        />
        <Information
          title="Tipo Sanguíneo:"
          information={
            data.tipoSanguineo ? data.tipoSanguineo.tipoSanguineo : ""
          }
        />
      </Group>
      <Group title="Filiação">
        <FiliacaoTableVisualizacao
          columns={columns}
          data={data.filiacoes.map((filiacao) => filiacao.filiacao)}
          updateFiliacoes={handleGetCrianca}
          idCrianca={id}
          idPJ={data.servicoAcolhimento?.idPessoaJuridica}
          dataNascimentoCA={data.dataNascimento}
        />
      </Group>
      <SimpleGrid
        mt="30px"
        columns={{ base: 1, sm: 2, lg: 5 }}
        spacing="20px"
        dir="rtl"
      >
        {excluir && (
          <>
            <Permission
              roleKeycloack={roleKeycloack}
              func={criancaFunc.excluir}
            >
              <CustomButton
                label="Confirmar Exclusão"
                onClick={() => {
                  backAlertDelete();
                }}
              />
            </Permission>
            <CustomButton
              label="Cancelar Exclusão"
              onClick={() => {
                history.push("/crianca");
              }}
            />
          </>
        )}
        <Permission roleKeycloack={roleKeycloack} func={criancaFunc.desligar}>
          {data.movimentacoes[0]?.motivoSituacao?.tipoSituacao?.id === 2 ||
          data.movimentacoes[0]?.movimentoMovimentacao?.tipoSituacaoMovimentacao
            ?.id === 2 ||
          data.movimentacoes[0]?.movimentoMovimentacao?.id === 2 ? (
            <CustomButton
              width={{ sm: "100%", md: "auto" }}
              label="Novo Acolhimento"
              onClick={() => {
                onOpenNovoAcolhimento();
              }}
            />
          ) : (
            ""
          )}
        </Permission>
        <Permission
          roleKeycloack={roleKeycloack}
          func={criancaFunc.editar}
          id={data?.servicoAcolhimento?.idPessoaJuridica}
          user={user}
          visualizar={true}
        >
          <CustomButton
            label="Editar"
            onClick={() => {
              history.push(`/crianca/editar/${id}`);
            }}
          />
        </Permission>
      </SimpleGrid>
      <CadastrarMovimentacaoModal
        isOpen={isOpenNovoAcolhimento}
        onOpen={onOpenNovoAcolhimento}
        data={data}
        movimentoDefault={true}
        setLoadingPainel={setLoadingPainel}
        idCrianca={id}
        dataNascimento={data.dataNascimento}
        onClose={() => {
          onCloseNovoAcolhimento();
        }}
        roleKeycloack={roleKeycloack}
        user={user}
        idPJ={idPJ}
        handleGetCriancaReload={handleGetCrianca}
      />
    </Flex>
  ) : (
    <LoadingSpinner loading={data === undefined} />
  );
};
